import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, TransparenciaInformacaoAdicionalGrupo } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class TransparenciaInformacaoAdicionalGrupoService extends BaseResourceService<TransparenciaInformacaoAdicionalGrupo> {

  constructor(
    protected injector: Injector
  ) {
    super(`transparencia-informacao-adicional-grupos`, injector);
  }

}
